<script setup lang="ts">
import { useFetchGeneral } from '~/api/service/general/index.service'
import HomeChartTitle from '~/components/@pages/home/HomeChartTitle.vue'
import PieChart from '~/components/chart/PieChart.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import { HOME_CHART_TOOLTIP, HOME_REFETCH_PARAMS } from '~/constants/general.const'
import { IMAGE_BASE_URL } from '~/constants/image.constant'
import { UNIT } from '~/environment-variables/unit.const'
import { generalParamType } from '~/types/general.type'
import { formatExponent } from '~/utils/numberFormat'

const { data, isLoading } = useFetchGeneral(HOME_REFETCH_PARAMS)

const exponentialValue = computed(() => {
  return formatExponent(data.value?.FBAI.OBJ.TBL ?? '0')
})

const pieChartData = computed(() => {
  if (!data.value) return []
  return data.value.FBAI.OBJ.BLLIST.map(i => {
    return {
      value: i.BL,
      name: i.ADDR.ADDR,
    }
  })
})
</script>

<template>
  <div>
    <CustomSuspense :is-loading="isLoading">
      <template #loading>
        <img
          :src="`${IMAGE_BASE_URL}/skeleton/home/pie-chart.png`"
          alt="balance skeleton"
        >
      </template>
      <template #default>
        <Card class="h-full p-8">
          <HomeChartTitle
            title="Balance"
            :tooltip="HOME_CHART_TOOLTIP[generalParamType.BALANCE]"
          />
          <PieChart
            class="mt-2"
            :data="pieChartData"
            :formatter="(params) => {
              //{a} for series name, {b} for data item name, {c} for data value, {d} for percentage.
              return `${params.name}<br/> <b>${setComma(params.value)} ${UNIT} (${params.percent}%)</b>`
            }"
          >
            <div class="balance-label">
              <span>{{ exponentialValue.num }}<template v-if="exponentialValue.power"> × 10<sup>{{
                exponentialValue.power
              }}</sup></template></span>
              <div class="unit">
                {{ UNIT }}
              </div>
            </div>
          </PieChart>
        </Card>
      </template>
    </CustomSuspense>
  </div>
</template>

<style scoped lang="scss">
.balance-label {
  @apply text-primary font-bold text-center;
  font-size: 20px;

  .unit {
    @apply text-primary/40 text-xl;
  }
}
</style>